goog.provide('el8.appchart.mainFeeds.reqAct');

goog.require('el8.appchart.mainFeeds.actions');
goog.require('el8.appchart.mainFeeds.billElationStaffRenderer');
goog.require('el8.appchart.mainFeeds.chart');
goog.require('el8.appchart.mainFeeds.reqActRenderer');
goog.require('el8.appchart.mainFeeds.reqActReactRenderMap');
goog.require('el8.appshared.letterFeedRenderer');
goog.require('el8.appshared.message');
goog.require('el8.appshared.signOff');
goog.require('el8.model.identify');
goog.require('el8.ptdata.fetch');
goog.require('el8.template.appchart.mainFeeds');
goog.require('el8.uiwidget.Feed');
goog.require('el8.appshared.react.renderNewMessageThread');


/**
 * See https://github.com/elationemr/hippo/wiki/Chart-Feed
 * for an overview of the various pieces of the chart feed,
 * which largely carry over to the reqact feed as well
 */
if (el8Globals['APP'].startswith('chart')) {
    el8.appchart.mainFeeds.reqAct = (function() {

        var that = new el8.uiwidget.Feed({
            container: $('#reqAct-feed-container'),
            name: 'reqAct',
            urlIndex: el8Globals['PATIENT_PATH'] + 'req-action-feed-index/',
            rendererFn: el8.appchart.mainFeeds.reqActRenderer,
            reactRenderMap: el8.appchart.mainFeeds.reqActReactRenderMap,
            fetchFn: function(arg, force, async) {
                // TODO: this is only necessary b/c there isn't a real-time message 
                //       invalidating the stale MessageThread
                if (arg.length) { //in case we get an object rather than array
                    for (var i=0; i < arg.length; i++) {
                        //always hard-refresh message threads, in case they have a new message on them
                        if (arg[i] && arg[i].model_class === 'MessageThread') {
                            el8.ptdata.messageThreads.remove(arg[i].id, true);
                        }
                    }
                }
                /* Whenever we have a new req act report, we want to make sure the 
                 * corresponding report feed refreshes. Below is a bit of hoop jumping 
                 * to only trigger when a *new* report is found, but it will save us 
                 * from a lot of unnecessary report feed refreshes. It makes up for the 
                 * fact that el8.ptdata.fetch does not trigger any entity set notifiers.
                 */
                var newReportIdsFetched = _.map(
                    _.filter((arg instanceof Array) ? arg : [arg],
                        function(obj) {
                            if (el8.model.idToModelClass(obj['id']) === 'Report') {
                                var report = el8.ptdata.reports.getById(obj['id']);
                                return !report; // return true if report not in cache
                            }
                            return false;
                        }
                    ), function(obj) { return obj['id']; });

                /* Fetch the items */
                var results = el8.ptdata.fetch(arg, force, async);

                /* Ensure the feed refreshes */
                el8.appchart.dialog.reports.ensureRefreshAllAffected(newReportIdsFetched);

                return results;
            },
            addlRenderItemFn: function(renderedItem, item) {
                if (!item) return;

                if (item.is('Letter') || item.is('LetterReceipt')) {
                    el8.appshared.letterFeedRenderer.render(renderedItem, item, true);
                }
                if (item.is('VisitNote') && el8Globals.ELATIONSTAFF) {
                    el8.appchart.mainFeeds.billElationStaffRenderer.render(renderedItem, item);
                }

                if (item.is('MessageThread') && el8Globals.FEATURES.NewOfficeMessages) {
                    el8.appshared.react.renderNewMessageThread(renderedItem, {
                        feedName: 'reqAct',
                        messages: [item.asSoyMap(true)],
                        itemId: item.getId(),
                        onReplySuccess: function refresh(data) {
                            el8.ptdata.messageThreads.create(data);
                            that.refresh();
                        }
                    });
                }
            },
            addlResetItemFn: function(item, renderedItem) {
                if (!item) return;

                if (item.is('Letter') || item.is('LetterReceipt')) {
                    el8.appshared.letterFeedRenderer.reset(renderedItem, item);
                }
                if (item.is('VisitNote') && el8Globals.ELATIONSTAFF) {
                    el8.appchart.mainFeeds.billElationStaffRenderer.reset(renderedItem);
                }
            },
            skeletonFn: el8.template.appchart.mainFeeds.reqAct,
            clickTriggerMap: el8.appchart.mainFeeds.actions.clickMap
        });

        that.getFirstUnreadReport = function() {
            var dataIndex = that.getIndex();
            var reportObj = _.find(dataIndex, 
                function(obj) { 
                    return el8.model.idToModelClass(obj['id']) === 'Report';
                }
            );
            return reportObj ? el8.ptdata.reports.getById(reportObj['id']) : null;
        };

        return that;

    })();
}
